import { ScanModes } from './ScanModes';

export enum PackageScanModesEvent {
  OnInit = 'onInit',
  OnCustomScanModeOptionChanged = 'onCustomScanModeOptionChanged',
  OnScanModeRadioSelectionChanged = 'onScanModeRadioSelectionChanged',
}

export class OnCustomScanModeOptionChanged extends CustomEvent<{ hasCentralScan: boolean }> {
  constructor(hasCentralScan: boolean) {
    super(PackageScanModesEvent.OnCustomScanModeOptionChanged, {
      detail: {
        hasCentralScan,
      },
      bubbles: true,
      composed: true,
    });
  }
}

export class OnScanModeRadioSelectionChanged extends CustomEvent<{
  selectedValue: ScanModes;
  hasCentralScan: boolean;
}> {
  constructor(selectedValue: ScanModes, hasCentralScan: boolean) {
    super(PackageScanModesEvent.OnScanModeRadioSelectionChanged, {
      detail: {
        selectedValue,
        hasCentralScan,
      },
      bubbles: true,
      composed: true,
    });
  }
}
